var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecorderMicrophone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/microphone",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(8.000000, 4.000000)",
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 17.25,
    x2: 8,
    y2: 23.25,
    id: "path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 23.25,
    x2: 11,
    y2: 23.25,
    id: "path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5,8.25 L0.5,11.25 C0.5,14.5637085 3.1862915,17.25 6.5,17.25 L9.5,17.25 C12.8137085,17.25 15.5,14.5637085 15.5,11.25 L15.5,8.25",
    id: "path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5,14.25 L6.5,14.25 C4.74141022,14.1427025 3.40037803,12.6340413 3.5,10.875 L3.5,4.125 C3.40037803,2.36595872 4.74141022,0.857297503 6.5,0.75 L9.5,0.75 C11.2585898,0.857297503 12.599622,2.36595872 12.5,4.125 L12.5,10.875 C12.599622,12.6340413 11.2585898,14.1427025 9.5,14.25 Z",
    id: "path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.5,
    y1: 5.25,
    x2: 6.5,
    y2: 5.25,
    id: "path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.5,
    y1: 5.25,
    x2: 12.5,
    y2: 5.25,
    id: "path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.5,
    y1: 8.25,
    x2: 6.5,
    y2: 8.25,
    id: "path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.5,
    y1: 8.25,
    x2: 12.5,
    y2: 8.25,
    id: "path"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecorderMicrophone);
export default __webpack_public_path__ + "static/media/recorder-microphone.168af64d04e70f4fcb01e349863da063.svg";
export { ForwardRef as ReactComponent };